import { AlternativeEditorReadModel } from "@Alternatives/Alternatives/Domain/readmodels";
import { EditorState } from "@common/Common";
import { ValidationError } from "@common/types";

export class AlternativeEditorDialogViewModel
{
    state: EditorState = EditorState.Closed;
    title: string | null = null;
    rm: AlternativeEditorReadModel | null = null;
    validationErrors: ValidationError[] = [];

    workspaceId: number;
    projectId: number;
    alternativesListId: number;
    alternativeId: string | null;
    formDefId: number | null;
    isUpdating: boolean = false;
    isCreating: boolean = false;
    isDeleting: boolean = false;

    showPreview(workspaceId: number, projectId: number, alternativesListId: number, formDefId: number)
    {
        this.reset();

        this.workspaceId = workspaceId;
        this.projectId = projectId;
        this.alternativesListId = alternativesListId;
        this.formDefId = formDefId;

        this.title = "Preview";
        this.state = EditorState.Preview;
    }

    showCreator(workspaceId: number, projectId: number, alternativesListId: number, formDefId: number | null, alternativeLabel?: string)
    {
        this.reset();

        this.workspaceId = workspaceId;
        this.projectId = projectId;
        this.alternativesListId = alternativesListId;
        this.formDefId = formDefId;

        this.title = `Create ${alternativeLabel}`;
        this.state = EditorState.Creator;
    }

    showEditor(workspaceId: number, projectId: number, alternativesListId: number, alternativeId: string, formDefId: number | null, alternativeLabel?: string)
    {
        this.reset();

        this.workspaceId = workspaceId;
        this.projectId = projectId;
        this.alternativesListId = alternativesListId;
        this.alternativeId = alternativeId;
        this.formDefId = formDefId;

        this.title = `Edit ${alternativeLabel}`;
        this.state = EditorState.Editor;
    }

    resetButtons()
    {
        this.isCreating = false;
        this.isUpdating = false;
        this.isDeleting = false;
    }

    reset()
    {
        this.rm = null;
        this.validationErrors = [];
        this.alternativeId = null;
        this.formDefId = null;

        this.resetButtons();
    }

    DisplayValidationErrors(errors: ValidationError[])
    {
        this.validationErrors = errors;
        this.resetButtons();
    }

    close()
    {
        this.state = EditorState.Closed;
    }
}